module directives {
    export module applicationcore {
        interface IUNSPSCCodeScope extends ng.IScope {
            ngModel: string;
            ngRequired: boolean;
            openUNSPSCCodeSearch(): void;          
            selected({ selectedItem }): void;
            ngDisabled: boolean;
        }

        export class unspscCodeDirective implements ng.IDirective {
            public restrict: 'E';
            public template = `
            <form name="inputForm">
                <p class="input-group input-group-sm has-feedback" ng-class="{'has-error': inputForm[name].$invalid}">
                    <input type="text" name="{{name}}" class="form-control" ng-model="ngModel" ng-required="ngRequired" ng-disabled="true" />
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-info" ng-click="openUNSPSCCodeSearch()" ng-disabled="ngDisabled">Search</button>
                    </span>
                </p>
            </form>
            `;
            public scope = {
                ngModel: "=",
                ngRequired: "=",    
                selected: "&",
                ngDisabled: "="
            }

            constructor(private $timeout: ng.ITimeoutService,
                private $uibModal: ng.ui.bootstrap.IModalService,
                private unspscCodeService: interfaces.applicationcore.IUNSPSCCodeService
            ) {
            }

            link = ($scope: IUNSPSCCodeScope, $element: ng.IAugmentedJQuery) => {
                $scope.openUNSPSCCodeSearch = () => {
                    this.$uibModal.open({
                        animation: true,
                        size: "lg",
                        template: `
                        <div class="modal-header">
                            <h3 class="modal-title" id="modal-title">UNSPSC Code List</h3>
                        </div>
                        <div class="modal-body" id="modal-body">
                            <gts-message-display messages="Messages"></gts-message-display>                           
                            <div class="col-md-12" style="padding-left:0px;padding-right:0px;">
                                <div bs-loading-overlay bs-loading-overlay-reference-id="unspscCode">
                                    <div ui-grid="unspscCodeCtrl.gvwGrid" ui-grid-pagination ui-grid-resize-columns ui-grid-selection class="gridFullScreen" ng-if="unspscCodeCtrl.showGrid">
                                        <div layout="column" layout-align="center center" class="grid-msg-overlay" ng-if="!unspscCodeCtrl.gvwGrid.data || unspscCodeCtrl.IsLoading">
                                            <div class="msg" ng-show="!unspscCodeCtrl.gvwConList.data && !unspscCodeCtrl.IsLoading">
                                                <span>No Rows</span>
                                            </div>
                                            <div class="loadingGrid" ng-show="unspscCodeCtrl.IsLoading">
                                                <i class="fa fa-spinner fa-spin"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary" type="button" ng-click="unspscCodeCtrl.ok()">Ok</button>
                            <button class="btn btn-info" type="button" ng-click="unspscCodeCtrl.cancel()">Close</button>
                        </div>`,
                        controller: class unspscCodeCtrl {
                            showGrid: boolean = false;
                            IsLoading: boolean = false;
                            pageNumber: number = 1;
                            pageSize: number = 25;
                            apiGrid: uiGrid.IGridApi;

                            constructor(private $scope: ng.IScope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                                private unspscCodeService: interfaces.applicationcore.IUNSPSCCodeService, 
                                private generalService: interfaces.applicationcore.IGeneralService, 
                                private $q: ng.IQService,
                                private $timeout: ng.ITimeoutService,                               
                                private bsLoadingOverlayService: interfaces.applicationcore.IbsLoadingOverlayService) {
    
                                this.showGrid = true;
                            }

                            gvwGrid: uiGrid.IGridOptions = {
                                data: [],
                                enableFiltering: true,
                                useExternalFiltering: true,
                                enableCellEdit: false,
                                useExternalSorting: true,
                                multiSelect: false,
                                enableColumnResizing: true,
                                enableRowSelection: true,
                                enableFullRowSelection: true,
                                paginationPageSizes: [25, 50, 75, 100],
                                paginationPageSize: 25,
                                useExternalPagination: true,
                                enableRowHeaderSelection: false,
                                enableHorizontalScrollbar: 2,
                                enableVerticalScrollbar: 1,
                                onRegisterApi: (gridApi) => {
                                    this.apiGrid = gridApi;
                                    gridApi.core.on.filterChanged(this.$scope, () => { this.loadUNSPSCCodeList() });
                                    gridApi.core.on.sortChanged(this.$scope, () => { this.loadUNSPSCCodeList() });
                                    gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => { 
                                        this.pageNumber = newPage;
                                        this.pageSize = pageSize;
                                        this.loadUNSPSCCodeList()
                                    });

                                    this.$timeout(() => {
                                        this.loadUNSPSCCodeList();
                                    });
                                },
                                columnDefs: [            
                                     {
                                    name: "UNSPSCCommodityCode",
                                    displayName: "UNSPSC Commodity Code",
                                    field: "UNSPSCCommodityCode",
                                    width: 125,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },       
                                     {
                                    name: "CommodityTitle",
                                    displayName: "Commodity Title",
                                    field: "CommodityTitle",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },
                                     {
                                    name: "CommodityDefinition",
                                    displayName: "Commodity Definition",
                                    field: "CommodityDefinition",
                                    width: 200,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },           
                                     {
                                    name: "Synonym",
                                    displayName: "Synonym",
                                    field: "Synonym",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    }, 
                                {
                                    name: "UNSPSCClass",
                                    displayName: "Class",
                                    field: "UNSPSCClass",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },        
                                    {
                                    name: "ClassTitle",
                                    displayName: "Class Title",
                                    field: "ClassTitle",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },                                                                                                                                                                                            
                                     {
                                    name: "ClassDefinition",
                                    displayName: "Class Definition",
                                    field: "ClassDefinition",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    }, 
                                    {
                                    name: "Family",
                                    displayName: "Family",
                                    field: "Family",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },
                                      {
                                    name: "FamilyTitle",
                                    displayName: "Family Title",
                                    field: "FamilyTitle",
                                    width: 100,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },
                                      {
                                    name: "FamilyDefinition",
                                    displayName: "Family Definition",
                                    field: "FamilyDefinition",
                                    width: 150,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    },
                                    {
                                    name: "Segment",
                                    displayName: "Segment",
                                    field: "Segment",
                                    width: 100,                                    
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    }, 
                                    {
                                    name: "SegmentTitle",
                                    displayName: "Segment Title",
                                    field: "SegmentTitle",
                                    width: 150,
                                    cellTemplate: '<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>',
                                    filterHeaderTemplate: `
                                            <div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters">
                                                <div class="input-group-sm">
                                                    <input type="text" class="form-control" ng-model="colFilter.term" ng-model-options="{ debounce: 1000 }"/>
                                                </div>
                                            </div>`
                                    }                                                                             
                                ]
                            };


                        
                            public loadUNSPSCCodeList() {

                                    var searchObject: interfaces.applicationcore.ISearchObject = {
                                        filters: [],
                                        sorts: []
                                    }

                                    if (this.apiGrid) {
                                        var grid = this.apiGrid.grid;
                    
                                        angular.forEach(grid.columns, (n: uiGrid.IGridColumn) => {
                                            if (n.filters[0].term) {
                                                searchObject.filters.push({ Name: n.name, Value: n.filters[0].term });
                                            }
                    
                                            if (n.sort.direction) {
                                                searchObject.sorts.push({
                                                    Name: n.name,
                                                    SortDirection: n.sort.direction === "asc" ? 0 : 1,
                                                    SortOrder: n.sort.priority
                                                });
                                            }
                    
                                        });
                                    }

       
                                    var UNSPSCCodeLookupSearch: interfaces.applicationcore.IUNSPSCCodeLookupSearch = {                                    
                                        connectSearch: searchObject,
                                        numberRecords: this.pageSize,
                                        pageNumber: this.pageNumber
                                    };


                                    this.IsLoading = true;
                                    this.unspscCodeService.getUNSPSCCodeList().query(UNSPSCCodeLookupSearch, (data) => {
                                        this.gvwGrid.data = data;
                                        if(data && data.length > 0) {
                                            this.gvwGrid.totalItems = data[0].NumRecords;
                                        } else {
                                            this.gvwGrid.totalItems = 0;
                                        }

                                        this.IsLoading = false;
                                    }, (errorResponse) => {
                                        this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data, this.$scope);
                                        this.IsLoading = false;
                                    });
            
                            }

                            cancel() {
                                this.$uibModalInstance.dismiss();
                            }
    
                            ok() {
                                if(this.apiGrid.selection.getSelectedRows().length > 0) {
                                    var selectedRow = this.apiGrid.selection.getSelectedRows()[0];

                                    this.$uibModalInstance.close(selectedRow);
                                }
                            }
                            
                        },
                        controllerAs: "unspscCodeCtrl",
                        resolve: {
                            
                        }
                    }).result.then(
                        (result: interfaces.applicationcore.UNSPSCCodeDisplay) => {
                            if(result) {
                                $scope.selected({selectedItem: result});
                            }
                        }
                    );
                }
            }

                            
            static factory(): ng.IDirectiveFactory {
                const directive = ($timeout, $uibModal,UNSPSCCodeService) => new unspscCodeDirective($timeout, $uibModal,UNSPSCCodeService);
                directive.$inject = ['$timeout',"$uibModal","unspscCodeService"];

                return directive;
            }
        }

        angular.module("app").directive("gtsUnspscCode", unspscCodeDirective.factory());
    }
}